import { FC } from 'react';
import { TbInfoCircle, TbUserBolt } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { OurDocsLink } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';
import {
    PreferenceModalHeader,
    PreferenceModalSiderOption,
} from '@/shared/components/modals/PreferenceModalPrimitives';
import InlineIconLabel from '@/shared/components/modals/ResourceCreationModals/CreateOAuthApplicationModal/components/InlineIconLabel';

const Sider: FC = () => {
    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                backgroundColor: token.colorBgBase,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}
        >
            <div>
                <PreferenceModalHeader description='Configure governed workspace access.' title='Custom Roles' />
                <div style={{ padding: '0.75rem 1rem' }}>
                    <div style={{ marginBottom: '0.75rem' }}>
                        <small style={{ color: token.colorTextTertiary }}>Role Builder</small>
                    </div>
                    <PreferenceModalSiderOption active>
                        <InlineIconLabel icon={<TbUserBolt />} label='Create Role' />
                    </PreferenceModalSiderOption>
                </div>
            </div>
            <div style={{ marginTop: 'auto', padding: '1rem' }}>
                <PlatformAlert
                    description={
                        <span>
                            Templates provide a starting point. Review every selected policy before creating the role.
                            Learn more in <OurDocsLink />
                        </span>
                    }
                    icon={<TbInfoCircle />}
                    showIcon
                    status='info'
                    title='Review template permissions'
                />
            </div>
        </div>
    );
};

export default Sider;
